import type { MenuProps } from "features/menu/blocks/Menu/Menu.types";
import MenuNode from "features/menu/elements/MenuNode";
import { useMenu } from "features/menu/useMenus";
import React from "react";

import "./Menu.css";

const Menu: React.FC<MenuProps> = ({ slug, variant = "flat", className }) => {
  const menu = useMenu(slug);

  if (!menu) return null;

  const rootClassName = ["menu", `menu--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={rootClassName}>
      <ul className="menu__list">
        {menu.items.map((item) => (
          <MenuNode
            key={item.id}
            item={item}
            variant={variant}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Menu;
